__turbopack_context__.v({
  "textarea": "O_FJPa_textarea",
  "textareadisabled": "O_FJPa_textareadisabled",
  "textareainvalid": "O_FJPa_textareainvalid",
  "textareasize_small": "O_FJPa_textareasize_small",
});
